import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import Media from "@qlik/qlik/src/components/Media";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { renderLinkedComponents } from "@qlik/qlik/src/components/registry";
import "@qlik/qlik/src/assets/vendor/slick/slick.css";
import "@qlik/qlik/src/assets/vendor/slick/slick-theme-tabbed-carousel.css";

const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="slick-arrow slick-next custom-arrow-wrapper">
            <button className="custom-next-arrow" onClick={onClick}>
                NEXT
            </button>
        </div>
    );
};

const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="slick-arrow slick-prev custom-arrow-wrapper">
            <button className="custom-prev-arrow" onClick={onClick}>
                PREV
            </button>
        </div>
    );
};

const CarouselNavItem = ({ el }) => {
    const icon = el.cardItem?.mediaIcon;
    const iconText = el.cardItem?.mediaIconText;

    // Determine if we should display icon only, text only, or both icon and text
    const displayIconAndText = icon && iconText;

    return (
        <div key={el.id} className={`carousel-icon-wrapper ${displayIconAndText ? "icon-and-text" : ""}`}>
            {icon && (
                <div className="carousel-icon-img-wrapper">
                    <Media media={icon} className="carousel-icon" />
                </div>
            )}
            {iconText && <div className="carousel-icon-text">{iconText}</div>}
        </div>
    );
};

const TabbedCarousel = ({ data }) => {
    const [navSlider, setNavSlider] = useState(null);
    const [contentSlider, setContentSlider] = useState(null);
    let sliderNav = useRef(null);
    let sliderContent = useRef(null);

    const { additionalConfiguration, multiItems } = data;

    const spacingClassName = getSpacingClassName(additionalConfiguration, "py-10 lg:py-30");
    const nrSlides = multiItems.length || 0;
    const enableCarouselDesktop = nrSlides >= 6;
    const enableCarouselMed = nrSlides >= 4;
    const enableCarouselSmall = nrSlides >= 2;

    // If less than 6 slides, then no arrows
    const navSliderSettings = {
        slidesToShow: 6,
        arrows: enableCarouselDesktop,
        focusOnSelect: true,
        centerMode: enableCarouselDesktop, // centermode true when arrows are true
        centerPadding: 0,
        infinite: enableCarouselDesktop, // infinte scroll true when arrows are true
        speed: 500,
        className: `nav-slider ${enableCarouselDesktop ? "nav-slider-carousel" : ""}`,
        nextArrow: enableCarouselDesktop ? <NextArrow /> : <React.Fragment />,
        prevArrow: enableCarouselDesktop ? <PrevArrow /> : <React.Fragment />,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    arrows: enableCarouselMed,
                    centerMode: enableCarouselMed,
                    infinite: enableCarouselMed,
                    nextArrow: enableCarouselMed ? <NextArrow /> : <React.Fragment />,
                    prevArrow: enableCarouselMed ? <PrevArrow /> : <React.Fragment />,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    arrows: enableCarouselSmall,
                    centerMode: enableCarouselSmall,
                    infinite: enableCarouselSmall,
                    nextArrow: enableCarouselSmall ? <NextArrow /> : <React.Fragment />,
                    prevArrow: enableCarouselSmall ? <PrevArrow /> : <React.Fragment />,
                },
            },
        ],
    };

    const contentSliderSettings = {
        slidesToShow: 1,
        fade: true,
        speed: 1000,
        className: "content-slider",
        nextArrow: <React.Fragment />,
        prevArrow: <React.Fragment />,
    };

    useEffect(() => {
        setNavSlider(sliderNav);
        setContentSlider(sliderContent);
    }, []);

    return (
        <section className={`${spacingClassName} multiplexTabbedCarousel`}>
            <div className="container">
                <Slider asNavFor={contentSlider} ref={(slider) => (sliderNav = slider)} {...navSliderSettings}>
                    {multiItems.map((el) => (
                        <CarouselNavItem el={el} key={el.id} />
                    ))}
                </Slider>
                <Slider asNavFor={navSlider} ref={(slider) => (sliderContent = slider)} {...contentSliderSettings}>
                    {multiItems.map((el) => renderLinkedComponents(el))}
                </Slider>
            </div>
        </section>
    );
};

export default TabbedCarousel;
